import { memo, useState } from "react";
import classnames from "classnames";
import { FullActionGroupType } from "types";
import { XIcon } from "@heroicons/react/outline";

interface IProps {
  title: string | undefined;
  createdAt: string | undefined;
  showName?: boolean;
  showCreatedAt?: boolean;
  className?: string;
  classNames?: { avatar?: string; name?: string; dotSeparator?: string };
  membersCount?: string;
  actionGroupUsers?: FullActionGroupType[];
}

interface IMembersPopupProps {
  membersList: FullActionGroupType[];
  membersCount: string;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
}

function MembersPopup({
  membersList,
  membersCount,
  setShow,
}: IMembersPopupProps) {
  return (
    <div className="absolute flex flex-col min-w-[200px] min-h-[200px] top-[100%] z-[100] w-full h-full bg-white border shadow-md rounded-lg ">
      <div className="flex flex-row justify-between px-2 pt-2">
        <div className="flex flex-row items-center gap-2">
          <p className="font-bold text-black">Members</p>
          <span className="h-1 w-1 rounded-full bg-gray-400" />
          <p>{`${membersCount}`}</p>
        </div>
        <div>
          <XIcon
            onClick={() => {
              setShow(false);
            }}
            className="h-6 w-6 shrink-0 cursor-pointer"
            aria-hidden="true"
          />
        </div>
      </div>
      <div
        className={classnames("border-b border-[#D1D5DB] w-full h-[1px] py-1 ")}
      />
      <div className=" py-1 overflow-auto">
        {membersList.length > 0 &&
          membersList.map((member) => {
            return (
              <div className="flex flex-col py-1">
                <div className="flex flex-row items-center justify-left gap-3 px-2">
                  <div className="rounded-full w-[24px] h-[24px] outline outline-[1px] outline-gray-200">
                    <img
                      className="  h-full w-full rounded-full object-cover"
                      alt="avatar"
                      src={member?.user?.avatar}
                    />
                  </div>
                  <p>{`${member?.user?.firstName} ${member?.user?.lastName}`}</p>
                </div>
                <div
                  className={classnames(
                    "border-b border-[#E5E7EB] w-full h-[1px] py-1 "
                  )}
                />
              </div>
            );
          })}
      </div>
    </div>
  );
}

function ActionGroupProfileBlock({
  title,
  createdAt,
  className,
  classNames,
  actionGroupUsers,
  showName = true,
  showCreatedAt = true,
  membersCount,
}: IProps) {
  const [showMembersPopup, setShowMembersPopup] = useState(false);

  return (
    <div
      className={classnames(
        "flex items-center justify-center gap-1",
        className
      )}
    >
      <div
        className={classnames(
          "  min-w-0 flex flex-row gap-4 flex-wrap items-center ",
          classNames?.name
        )}
      >
        {showName && (
          <span className="text-sm  text-gray-700 group-hover:text-gray-900 font-semibold  overflow-ellipsis overflow-hidden whitespace-nowrap       ">
            {title}
          </span>
        )}
        {membersCount !== undefined && (
          <div className=" relative self-start">
            <p
              onClick={() => {
                if (Number(membersCount) > 0) setShowMembersPopup(true);
              }}
              className="  font-normal text-[#999999] hover:text-black cursor-pointer line-clamp-2"
            >{`(${membersCount} ${
              Number(membersCount) === 1 ? "member" : "members"
            })`}</p>
            {showMembersPopup && (
              <MembersPopup
                membersCount={membersCount}
                membersList={actionGroupUsers || []}
                setShow={setShowMembersPopup}
              />
            )}
          </div>
        )}
        <span
          className={classnames(
            "rounded-full h-1 w-1 bg-[#666666]  ",
            classNames?.dotSeparator
          )}
        />
        {showCreatedAt && (
          <span className="text-sm  text-gray-400 group-hover:text-gray-700 font-light leading-5 overflow-ellipsis overflow-hidden whitespace-nowrap ">
            {createdAt}
          </span>
        )}
      </div>
    </div>
  );
}

export default memo(ActionGroupProfileBlock);
